<template>
  <section v-if="firstArticle">
    <div class="container py-5">
      <div class="row d-flex">
        <div class="col-12 col-lg-6">
          <blog-article :article="firstArticle" v-if="firstArticle.title" />
        </div>
        <div class="col-12 col-lg-6 mt-5 px-xxl-5 mt-lg-0">
          <div class="ratio ratio-1x1">
            <div class="ratio ratio-636x667">
              <img
                src="../../../../assets/images/black-white-girl.png"
                alt="smiling-girl-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "ToolsMarketResearchSection",
};
</script>
<script setup>
import { defineProps } from "vue";
import BlogArticle from "@/components/blog/index/background-card/BlogArticle";

defineProps({
  firstArticle: {
    type: Object,
    default: null,
  },
});
</script>

<style scoped></style>
